import { app } from '../../../app';
import { Controller } from './users-shared-notes.controller';

app.component('userSharedNotes', {
    bindings: {sharedNotes: '<'},
    controller: Controller,
    templateUrl: require('./users-shared-notes.html'),
});


// WEBPACK FOOTER //
// ./src/portal/states/user/users-shared-accounts/users-shared-notes.component.js